function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { formValueSelector, reduxForm, Form } from "redux-form";
import { Tooltip, Fade } from "reactstrap";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Loading from "../../../../components/Loading";
import Stepper from "../../../../components/mui/material/Stepper";
import { operationTypes, boostStates } from "../../../../constants";
import { loadBoostsByStateAndUserId } from "../../../../actions";
import ExchangeWizardFormAmountAvailableBuyStep from "./ExchangeWizardFormAmountAvailableBuyStep";
import ExchangeWizardFormAmountAvailableSellStep from "./ExchangeWizardFormAmountAvailableSellStep";
import ExchangeWizardFormBoostStep from "./ExchangeWizardFormBoostStep";
import ExchangeWizardFormBrokerStep from "./ExchangeWizardFormBrokerStep";
import ExchangeWizardFormCurrencyAmountStep from "./ExchangeWizardFormCurrencyAmountStep";
import ExchangeWizardFormGoalStep from "./ExchangeWizardFormGoalStep";
import ExchangeWizardFormInvestmentItemAmountStep from "./ExchangeWizardFormInvestmentItemAmountStep";
import ExchangeWizardFormPriceStep from "./ExchangeWizardFormPriceStep";
import ExchangeWizardFormQuoteStep from "./ExchangeWizardFormQuoteStep";
import ExchangeWizardFormVariantInvestmentItemStep from "./ExchangeWizardFormVariantInvestmentItemStep";
// import ExchangeWizardFormButtonGroup from "./ExchangeWizardFormButtonGroup";
import validate from "./validate";
var tKey = "contexts.ExchangeContext.CreateExchangeModal.ExchangeWizardForm";
var selector = formValueSelector("exchangeWizard");
var getNextStep = function getNextStep(step, nextStepProps) {
  step === 0 && nextStepProps.variantInvestmentItem && step++;
  step === 1 && nextStepProps.broker && step++;
  step === 2 && nextStepProps.goal && step++;
  step === 3 && nextStepProps.price && nextStepProps.variantInvestmentItemRoot && step++;
  step === 4 && step++;
  step === 5 && step++;
  step === 6 && nextStepProps.investmentItemAmount && step++;
  step === 7 && step++;
  return step;
};
function ExchangeWizardForm(props) {
  var initialValues = props.initialValues,
    handleSubmit = props.handleSubmit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var boostsCall = useSelector(function (state) {
    return state.apiCalls.loadBoostsByStateAndUserId[[boostStates.USABLE, authUserId].join("-")] || {};
  });
  var boosts = useSelector(function (state) {
    return state.entities.boosts.byStateAndUserId[[boostStates.USABLE, authUserId].join("-")];
  }) || [];
  var type = useSelector(function (state) {
    return selector(state, "type");
  });
  var variantInvestmentItem = useSelector(function (state) {
    return selector(state, "variantInvestmentItem");
  });
  var variantInvestmentItemRoot = useSelector(function (state) {
    return selector(state, "variantInvestmentItemRoot");
  });
  var broker = useSelector(function (state) {
    return selector(state, "broker");
  });
  var goal = useSelector(function (state) {
    return selector(state, "goal");
  });
  var price = useSelector(function (state) {
    return selector(state, "price");
  });
  var investmentItemAmount = useSelector(function (state) {
    return selector(state, "investmentItemAmount");
  });
  var exchangeNow = useSelector(function (state) {
    return selector(state, "exchangeNow");
  });
  var nextStepProps = {
    variantInvestmentItem: variantInvestmentItem,
    variantInvestmentItemRoot: variantInvestmentItemRoot,
    broker: broker,
    goal: goal,
    price: price,
    investmentItemAmount: investmentItemAmount
  };
  var _useState = useState(getNextStep(0, nextStepProps)),
    _useState2 = _slicedToArray(_useState, 2),
    activeStep = _useState2[0],
    setActiveStep = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    tooltipOpen = _useState4[0],
    setTooltip = _useState4[1];
  var _useState5 = useState(/*#__PURE__*/React.createRef()),
    _useState6 = _slicedToArray(_useState5, 1),
    variantInvestmentItemStepRef = _useState6[0];
  var _useState7 = useState(/*#__PURE__*/React.createRef()),
    _useState8 = _slicedToArray(_useState7, 1),
    brokerStepRef = _useState8[0];
  var _useState9 = useState(/*#__PURE__*/React.createRef()),
    _useState10 = _slicedToArray(_useState9, 1),
    goalStepRef = _useState10[0];
  var _useState11 = useState(/*#__PURE__*/React.createRef()),
    _useState12 = _slicedToArray(_useState11, 1),
    priceStepRef = _useState12[0];
  var _useState13 = useState(/*#__PURE__*/React.createRef()),
    _useState14 = _slicedToArray(_useState13, 1),
    balanceStepRef = _useState14[0];
  var _useState15 = useState(/*#__PURE__*/React.createRef()),
    _useState16 = _slicedToArray(_useState15, 1),
    boostStepRef = _useState16[0];
  var _useState17 = useState(/*#__PURE__*/React.createRef()),
    _useState18 = _slicedToArray(_useState17, 1),
    investmentItemAmountStepRef = _useState18[0];
  var _useState19 = useState(/*#__PURE__*/React.createRef()),
    _useState20 = _slicedToArray(_useState19, 1),
    currencyAmountStepRef = _useState20[0];
  var _useState21 = useState(/*#__PURE__*/React.createRef()),
    _useState22 = _slicedToArray(_useState21, 1),
    quoteStepRef = _useState22[0];
  function toggleTooltip(key) {
    setTooltip(key === tooltipOpen ? undefined : key);
  }
  function handleNextStep() {
    setActiveStep(getNextStep(activeStep, nextStepProps));
  }
  function scrollToCurrentRef() {
    var ref;
    if (activeStep === 0) ref = variantInvestmentItemStepRef;else if (activeStep === 1) ref = brokerStepRef;else if (activeStep === 2) ref = goalStepRef;else if (activeStep === 3) ref = priceStepRef;else if (activeStep === 4) ref = balanceStepRef;else if (activeStep === 5) ref = boostStepRef;else if (activeStep === 6) ref = investmentItemAmountStepRef;else if (activeStep === 7) ref = currencyAmountStepRef;else if (activeStep === 8) ref = quoteStepRef;
    ref && ref.current && window.scrollTo({
      left: 0,
      top: ref.current.offsetTop - 4,
      behavior: "smooth"
    });
  }
  useEffect(function () {
    props.loadBoostsByStateAndUserId(boostStates.USABLE, authUserId);
  }, []);
  useEffect(function () {
    handleNextStep();
    scrollToCurrentRef();
  }, Object.values(nextStepProps));
  var steps = [{
    qualify: true,
    label: t("".concat(tKey, ".step_variant"), {
      operationType: type === operationTypes.BUY ? t("".concat(tKey, ".step_variant_buy")) : t("".concat(tKey, ".step_variant_sell"))
    }),
    tooltip: t("".concat(tKey, ".step_variant_tooltip")),
    component: /*#__PURE__*/React.createElement(ExchangeWizardFormVariantInvestmentItemStep, _extends({
      ref: variantInvestmentItemStepRef,
      disabled: exchangeNow
    }, props))
  }, {
    qualify: true,
    label: t("".concat(tKey, ".step_broker")),
    component: /*#__PURE__*/React.createElement(ExchangeWizardFormBrokerStep, _extends({
      ref: brokerStepRef,
      disabled: exchangeNow
    }, props))
  }, {
    qualify: true,
    label: t("".concat(tKey, ".step_goal")),
    component: /*#__PURE__*/React.createElement(ExchangeWizardFormGoalStep, _extends({
      ref: goalStepRef,
      disabled: exchangeNow
    }, props))
  }, {
    qualify: true,
    label: t("".concat(tKey, ".step_lastPrice")),
    component: /*#__PURE__*/React.createElement(ExchangeWizardFormPriceStep, _extends({
      ref: priceStepRef
    }, props))
  }, {
    qualify: true,
    label: t("".concat(tKey, ".step_amountAvailable")),
    tooltip: t("".concat(tKey, ".step_amountAvailable_tooltip")),
    component: type === operationTypes.BUY ? /*#__PURE__*/React.createElement(ExchangeWizardFormAmountAvailableBuyStep, _extends({
      ref: balanceStepRef
    }, props)) : /*#__PURE__*/React.createElement(ExchangeWizardFormAmountAvailableSellStep, _extends({
      ref: balanceStepRef
    }, props))
  }, {
    qualify: boosts && boosts.length > 0,
    label: t("".concat(tKey, ".step_boost")),
    component: /*#__PURE__*/React.createElement(ExchangeWizardFormBoostStep, _extends({
      ref: boostStepRef,
      disabled: exchangeNow
    }, props))
  }, {
    qualify: true,
    label: t("".concat(tKey, ".step_investmentItemAmount"), {
      operationType: type === operationTypes.BUY ? t("".concat(tKey, ".step_investmentItemAmount_buy")) : t("".concat(tKey, ".step_investmentItemAmount_sell"))
    }),
    component: /*#__PURE__*/React.createElement(ExchangeWizardFormInvestmentItemAmountStep, _extends({
      ref: investmentItemAmountStepRef,
      disabled: exchangeNow
    }, props))
  }, {
    qualify: true,
    label: t("".concat(tKey, ".step_currencyAmount")),
    component: /*#__PURE__*/React.createElement(ExchangeWizardFormCurrencyAmountStep, _extends({
      ref: currencyAmountStepRef,
      disabled: exchangeNow
    }, props))
  }, {
    qualify: true,
    label: t("".concat(tKey, ".step_quote")),
    component: /*#__PURE__*/React.createElement(ExchangeWizardFormQuoteStep, _extends({
      ref: quoteStepRef
    }, props))
  }];
  if (boostsCall.isFetching) return /*#__PURE__*/React.createElement(Loading, null);

  // TODO react-select must work with custom entities
  initialValues.broker = initialValues.broker && _objectSpread({
    label: initialValues.broker.name,
    value: initialValues.broker.id
  }, initialValues.broker);
  initialValues.goal = initialValues.goal && _objectSpread({
    label: initialValues.goal.displayableName,
    value: initialValues.goal.id
  }, initialValues.goal);
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    orientation: "vertical",
    style: {
      backgroundColor: "transparent",
      padding: 0
    }
  }, steps.map(function (step, i) {
    return step.qualify && /*#__PURE__*/React.createElement(Step, {
      key: step.label,
      expanded: i <= activeStep
    }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement("span", null, step.label), step.tooltip && /*#__PURE__*/React.createElement("span", {
      className: "ms-2"
    }, /*#__PURE__*/React.createElement("i", {
      id: "exchangeWizardFormTooltip".concat(i),
      className: "fa fa-info-circle"
    }), /*#__PURE__*/React.createElement(Tooltip, {
      hideArrow: true,
      isOpen: tooltipOpen === i,
      toggle: function toggle() {
        return toggleTooltip(i);
      },
      target: "exchangeWizardFormTooltip".concat(i),
      innerClassName: "rounded"
    }, step.tooltip))), /*#__PURE__*/React.createElement(StepContent, null, /*#__PURE__*/React.createElement(Fade, null, step.component)));
  })));
}
ExchangeWizardForm = reduxForm({
  form: "exchangeWizard",
  forceUnregisterOnUnmount: true,
  validate: validate
})(ExchangeWizardForm);
export default connect(undefined, {
  loadBoostsByStateAndUserId: loadBoostsByStateAndUserId
})(ExchangeWizardForm);
ExchangeWizardForm.propTypes = {
  loadBoostsByStateAndUserId: PropTypes.func
};